module.exports = __webpack_public_path__ + "static/media/login_full_bg7.12a7b442.jpg";